import React, { useContext, useEffect, useState } from "react";
import { GameContext } from "../../store/game/GameContext";
import { getMemberGame, getMyGame, getAllGames } from "../../api/user";
import CardGridSkeleton from "../../components/Skeleton/CardGridSkeleton";
import Welcome from "./Welcome";
import Game from "./Game";
import GameSearchBar from "../../components/Sidebar/GameSearchBar";
import { useOutletContext } from "react-router";
import { useLocation } from "react-router-dom";

const MyGames = () => {
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const { gameList, fetching, addGamesFromServer, setFetching } =
    useContext(GameContext);
  const { search } = useOutletContext();

  const location = useLocation();

  const viewMode = location.state?.viewMode;


  const fetchGame = async (controller, viewMode) => {
    try {
      setFetching(true);
      let response;

      if (viewMode === "creator") {
        // Fetch games where user_id matches in the games table (Creator view)
        response = await getMyGame({
          signal: controller.signal,
          userId: userInfo.id,
        });
      } else if (viewMode === "member") {
        // Fetch games where user_id matches in the game_member table (Member view)
        response = await getMemberGame({
          signal: controller.signal,
          memberId: userInfo.id,
        });
      } else {
        // Fetch all games (All Games view)
        response = await getAllGames({
          signal: controller.signal,
          userId: userInfo.id,
        });
      }

      if (response?.status === 200) {
        addGamesFromServer(response.data.data);
      } else {
        console.log("Error occurred");
      }
    } catch (error) {
      if (error.name === "AbortError") {
        console.log("Fetch aborted");
      } else {
        console.log(error);
      }
    } finally {
      setFetching(false);
    }
  };

  useEffect(() => {
      localStorage.removeItem("game_type");
      localStorage.removeItem("isAuthenticated");

    const controller = new AbortController();
    fetchGame(controller, viewMode);

    return () => {
      controller.abort();
      console.log("Clean up: fetch aborted");
    };
  }, [viewMode]); // Re-fetch when viewMode changes

  // Filter games based on search query in title or description
  const filteredGames = gameList.filter(
    (game) =>
      (game.title && game.title.toLowerCase().includes(search.toLowerCase())) ||
      (game.description &&
        game.description.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <>

      <div className={`${gameList.length === 0 ? "block" : "grid"} grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 lg:gap-x-16 gap-x-8 gap-y-7 mt-5 md:mt-12 pl-8 pr-5 min-h-48`}>
        {fetching ? (
          <CardGridSkeleton cards={5} />
        ) : (
          <>
            {/* Show Welcome if no games in DB and no search query */}
            {gameList.length === 0 && !search && <Welcome />}

            {/* Show "No games found" if there are games but none match the search query */}
            {gameList.length > 0 && filteredGames.length === 0 && (
              <p>No league found with that title or description.</p>
            )}

            {/* Render the filtered games */}
            {filteredGames.map((game) => (
              <Game
                key={game.id}
                game={game}
                viewMode={viewMode}
                showEditButton
              />
            ))}
          </>
        )}
      </div>
    </>
  );
};

export default MyGames;
